module.exports = __webpack_public_path__ + "static/media/loader.734d776b.svg";